const authority = process.env.VUE_APP_OIDC_BASE || 'https://test-token.baloise.be/oauth';
const redirectUri = `${window.location.protocol}//${window.location.host}`;

// getUrlParameter(name) {
//   name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
//   var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
//   var results = regex.exec(location.search);
//   return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
// };

export default {
  authority,
  metadata: {
    issuer: process.env.VUE_APP_OIDC_ISSUER,
    authorization_endpoint: process.env.VUE_APP_OIDC_AUTHORIZATION_ENDPOINT,
    userinfo_endpoint: process.env.VUE_APP_OIDC_USER_INFO_ENDPOINT,
    end_session_endpoint: process.env.VUE_APP_OIDC_END_SESSION_ENDPOINT,
    jwks_uri: process.env.VUE_APP_OIDC_JWKS_URI,
  },
  redirectUri,
  clientId: process.env.VUE_APP_CLIENT_ID,
  responseType: 'id_token token',
  scope: 'openid harukey_ipt80',
  extraQueryParams: { userType: window.location.pathname.toLowerCase().includes('broker') ? 'broker' : 'internal' },
};
